import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "sony_cart";

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const add = (product, qty = 1, variant = null) => {
    const key = product.slug + "-" + (variant?.vid || "base");
    const price = variant?.price ?? product.price;
    setItems((prev) => {
      const existing = prev.find((i) => i.key === key);
      if (existing) {
        return prev.map((i) =>
          i.key === key ? { ...i, qty: Math.min(i.qty + qty, 20) } : i
        );
      }
      return [
        ...prev,
        { key, slug: product.slug, vid: variant?.vid || null, variantName: variant?.name || null,
          name: product.name, price, image: product.image, qty },
      ];
    });
    setOpen(true);
  };

  const setQty = (key, qty) => {
    if (qty <= 0) {
      setItems((prev) => prev.filter((i) => i.key !== key));
    } else {
      setItems((prev) => prev.map((i) => (i.key === key ? { ...i, qty } : i)));
    }
  };

  const remove = (key) => setItems((prev) => prev.filter((i) => i.key !== key));
  const clear = () => setItems([]);

  const { subtotal, count } = useMemo(() => {
    return {
      subtotal: items.reduce((s, i) => s + i.price * i.qty, 0),
      count: items.reduce((s, i) => s + i.qty, 0),
    };
  }, [items]);

  return (
    <CartContext.Provider
      value={{ items, add, setQty, remove, clear, subtotal, count, open, setOpen }}
    >
      {children}
    </CartContext.Provider>
  );
};
